import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, FormGroup, ValidationErrors, NgForm, FormGroupDirective, FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';

@Directive({
  selector: '[FieldMatch]',
  providers: [{ provide: NG_VALIDATORS, useExisting: FieldMatchDirective, multi: true }]
})
export class FieldMatchDirective implements Validator {
  @Input('FieldMatch') matchWith: string[] = [];

  validate(f: FormGroup): ValidationErrors {

    let control1 = f.get(this.matchWith[0]);
    let control2 = f.get(this.matchWith[1]);

    if (!control1 || !control2) {
      return null;
    }

    if (control1.value !== control2.value) {
      return { 'passwordMatchFailiure': true };
    }
  }
}

/** Error when the parent is invalid */
export class FieldMatchErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.invalid;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/field-match.directive.ts